import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import ServicesSection from '../components/home/ServicesSection';
import PartnersSection from '../components/home/PartnersSection';
import ContactSection from '../components/home/ContactSection';
import { ANIMATION_VARIANTS } from '../constants';
import { 
  useFloatingParticles,
  usePerformanceMonitoring
} from '../hooks/useAnimations';

const HomePage: React.FC = () => {
  usePerformanceMonitoring('HomePage');
  
  // Reduce particle count for better performance
  const { particlesRef, containerClasses: particlesContainerClasses, particles } = useFloatingParticles(50);
  
  // Memoize particles to prevent re-renders
  const memoizedParticles = useMemo(() => particles, []);

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={ANIMATION_VARIANTS.fadeIn}
      className="min-h-screen relative"
    >

      {/* Global Floating Particles Background - Optimized */}
      <div 
        ref={particlesRef} 
        className={`${particlesContainerClasses} fixed inset-0 z-50`}
        style={{
          willChange: 'contents',
          contain: 'layout style paint'
        }}
      >
        {memoizedParticles.map((particle) => (
          <div
            key={particle.id}
            className={particle.classes}
            style={particle.style}
          />
        ))}
      </div>

      {/* Page Content */}
      <div className="relative">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <PartnersSection />
        <ContactSection />
      </div>
    </motion.div>
  );
};

export default HomePage;
